import GestioneDemo from "./GestioneDemo";
import DemoLeads from "./DemoLeads";
import DemoMenuEditor from "./DemoMenuEditor";
import AngryChefWrapper from "./game/AngryChef/AngryChefWrapper";
import ScacchiGame from "./ScacchiGame";
import Crucipuzzle from "./Crucipuzzle";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "./firebase";
import NotFound from "./NotFound";
import MenuDigitaleRistoranti from "./MenuDigitaleRistoranti";
import StreetFood from "./StreetFood";
import AppAsporto from "./AppAsporto";
import MenuAI from "./MenuAI";
import Login from "./Login";
import DashboardGestore from "./DashboardGestore";
import DashboardCassa from "./DashboardCassa";
import DashboardCucina from "./DashboardCucina";
import DashboardCameriere from "./DashboardCameriere";
import OrdersDashboard from "./OrdersDashboard";
import MenuEditor from "./MenuEditor";
import GestioneCamerieri from "./GestioneCamerieri";
import ReportGestore from "./ReportGestore";
import ReportAdmin from "./ReportAdmin";
import AdminLocali from "./AdminLocali";
import VisualizzaLocali from "./VisualizzaLocali";
import QRCodeGenerator from "./QRCodeGenerator";
import GestioneUtenti from "./GestioneUtenti";
import DashboardAdmin from "./DashboardAdmin";
import AnalyticsAccessi from "./AnalyticsAccessi";
import RegistrazioneUtente from "./RegistrazioneUtente";
import ImageUploader from "./ImageUploader";
import MenuView from "./MenuView";
import Demo from "./Demo";
import ResetPasswordPage from "./ResetPasswordPage";
import MenuAsporto from "./MenuAsporto";
import MenuAsportoOpt from "./MenuAsportoOpt";
import QrAsporto from "./QrAsporto";
import GestioneBanner from "./GestioneBanner";
import Sponsor from "./Sponsor";
import GestioneSponsor from "./GestioneSponsor";
import GestionePromozioni from "./GestionePromozioni";
import GestioneBannerPromozionale from "./GestioneBannerPromozionale";
import AiAssistant from "./AiAssistant";
import AIConsole from "./ai/AI";
import AIPreferenze from "./ai/AIPreferenze";
import Pricing from "./Pricing";
import TableRedirect from "./TableRedirect";
import ProtectedRoute from "./ProtectedRoute";
import CookieConsent from "./CookieConsent";
import Home from "./Home";

import Contatti from "./Contatti";
import Giochi from "./Giochi";
import TrisGame from "./TrisGame";
import Memory from "./Memory";
import PrivacyPolicy from "./PrivacyPolicy";
import CookiePolicy from "./CookiePolicy";


import MilionarioGame from "./MilionarioGame";
import PiattoManWrapper from "./game/PiattoMan/PiattoManWrapper";
import ChefRunWrapper from "./game/ChefRun/ChefRunWrapper";


function App() {
  const [user] = useAuthState(auth);

  return (
    <>
      <Routes>
        {/* Login */}
  <Route path="/login" element={<Login />} />

  <Route path="/reset-password" element={<ResetPasswordPage />} />

    <Route
      path="/adminlocali"
      element={
        <ProtectedRoute ruoliConsentiti={["admin"]}>
          <AdminLocali />
        </ProtectedRoute>
      }
    />

  {/* Dashboard Gestore */}
  <Route
    path="/dashboard-gestore"
    element={
      <ProtectedRoute ruoliConsentiti={["gestore", "admin"]}>
        <DashboardGestore />
      </ProtectedRoute>
    }
  />

  {/* Assistente AI NUOVO */}
  <Route
    path="/ai"
    element={
      <ProtectedRoute ruoliConsentiti={["gestore", "admin"]}>
        <AIConsole />
      </ProtectedRoute>
    }
  />        
              {/* Registrazione Utente */}
              <Route
                path="/registrazione-utente"
                element={
                  <ProtectedRoute ruoliConsentiti={["admin"]}>
                    <RegistrazioneUtente />
                  </ProtectedRoute>
                }
              />
  

  {/* Preferenze AI NUOVO */}
  <Route
    path="/ai-preferenze"
    element={
      <ProtectedRoute ruoliConsentiti={["gestore", "admin"]}>
        <AIPreferenze />
      </ProtectedRoute>
    }
  />

  {/* Dashboard Cassa */}
  <Route
    path="/dashboard-cassa"
    element={
      <ProtectedRoute ruoliConsentiti={["cassa", "gestore"]}>
        <DashboardCassa />
      </ProtectedRoute>
    }
  />


  {/* Dashboard Cucina */}
  <Route
    path="/dashboard-cucina"
    element={
      <ProtectedRoute ruoliConsentiti={["gestore"]}>
        <DashboardCucina />
      </ProtectedRoute>
    }
  />

  {/* Ordini */}
  <Route
    path="/ordersdashboard"
    element={
      <ProtectedRoute ruoliConsentiti={["gestore"]}>
        <OrdersDashboard />
      </ProtectedRoute>
    }
  />

  {/* Gestione Camerieri */}
  <Route
    path="/gestione-camerieri"
    element={
      <ProtectedRoute ruoliConsentiti={["admin", "gestore"]}>
        <GestioneCamerieri />
      </ProtectedRoute>
    }
  />


  {/* Modifica Menu */}
  <Route
    path="/menueditor"
    element={
      <ProtectedRoute ruoliConsentiti={["admin", "gestore"]}>
        <MenuEditor />
      </ProtectedRoute>
    }
  />

  <Route
    path="/demo-menu-editor/:localeTag"
    element={
      <ProtectedRoute ruoliConsentiti={["admin"]}>
        <DemoMenuEditor />
      </ProtectedRoute>
    }
  />

  {/* Report Gestore (CORRETTO) */}
  <Route
    path="/reportgestore"
    element={
      <ProtectedRoute ruoliConsentiti={["gestore", "admin"]}>
        <ReportGestore />
      </ProtectedRoute>
    }
  />

  {/* Admin: Visualizza Locali */}
  <Route
    path="/visualizzalocali"
    element={
      <ProtectedRoute ruoliConsentiti={["admin"]}>
        <VisualizzaLocali />
      </ProtectedRoute>
    }
  />

  {/* Admin: Genera QR */}
  <Route
    path="/qr-generator"
    element={
      <ProtectedRoute ruoliConsentiti={["admin"]}>
        <QRCodeGenerator />
      </ProtectedRoute>
    }
  />

  {/* Admin: Gestione Utenti */}
  <Route
    path="/gestione-utenti"
    element={
      <ProtectedRoute ruoliConsentiti={["admin"]}>
        <GestioneUtenti />
      </ProtectedRoute>
    }
  />

  {/* Admin: Gestione Banner */}
  <Route
    path="/gestione-banner"
    element={
      <ProtectedRoute ruoliConsentiti={["admin", "gestore"]}>
        <GestioneBanner />
      </ProtectedRoute>
    }
  />

  {/* Admin: Sponsor Hub */}
  <Route
    path="/sponsor"
    element={
      <ProtectedRoute ruoliConsentiti={["admin"]}>
        <Sponsor />
      </ProtectedRoute>
    }
  />

  {/* Admin: Gestione Sponsor */}
  <Route
    path="/gestione-sponsor"
    element={
      <ProtectedRoute ruoliConsentiti={["admin"]}>
        <GestioneSponsor />
      </ProtectedRoute>
    }
  />

  {/* Gestore: Gestione Promozioni */}
  <Route
    path="/gestione-promozioni"
    element={
      <ProtectedRoute ruoliConsentiti={["gestore"]}>
        <GestionePromozioni />
      </ProtectedRoute>
    }
  />

  {/* Gestore: Gestione Banner Promozionali */}
  <Route
    path="/gestione-banner-promozionale"
    element={
      <ProtectedRoute ruoliConsentiti={["gestore"]}>
        <GestioneBannerPromozionale />
      </ProtectedRoute>
    }
  />

  {/* Test immagine */}
  <Route path="/image-uploader" element={<ImageUploader />} />

  {/* Cliente: Menu QR */}
  <Route path="/menu/:localeTag/:tableId" element={<MenuView />} />

  {/* Cliente: Giochi */}
  <Route path="/giochi/:localeTag/:tableId" element={<Giochi />} />

  {/* Cliente: Tris */}
  <Route path="/tris/:localeTag/:tableId" element={<TrisGame />} />

<Route path="/scacchi/:localeTag/:tableId" element={<ScacchiGame />} />

  {/* Cliente: Crucipuzzle */}
  <Route path="/crucipuzzle/:localeTag/:tableId" element={<Crucipuzzle />} />

  {/* Cliente: Memory */}
  <Route path="/memory/:localeTag/:tableId" element={<Memory />} />


  {/* Cliente: Milionario */}
  <Route path="/milionario/:localeTag/:tableId" element={<MilionarioGame />} />

  {/* Cliente: PiattoMan */}
  <Route
    path="/piattoman/:localeTag/:tableId"
    element={
      <PiattoManWrapper />
    }
  />


  {/* Cliente: ChefRun */}
  <Route
    path="/chefrun/:localeTag/:tableId"
    element={<ChefRunWrapper />} 
  />

  {/* Cliente: AngryChef */}
  <Route
    path="/angrychef/:localeTag/:tableId"
    element={<AngryChefWrapper />}
  />

  {/* Menu asporto */}
  <Route path="/menu-asporto/:localeTag" element={<MenuAsporto />} />

  {/* Menu asporto OPT (pubblico, senza login) */}
  <Route path="/menu-asporto-opt/:localeTag" element={<MenuAsportoOpt />} />

  <Route
  path="/qr-asporto"
  element={
    <ProtectedRoute ruoliConsentiti={["gestore", "admin"]}>
      <QrAsporto />
    </ProtectedRoute>
  }
/>

  {/* Cameriere */}
  <Route path="/dashboard-cameriere" element={<DashboardCameriere />} />

  {/* Menu Cameriere */}
  <Route
    path="/menu-cameriere/:localeTag/:cameriereId"
    element={<DashboardCameriere />}
  />

  <Route path="/table-redirect" element={<TableRedirect />} />

  {/* Admin: Dashboard */}

  <Route
    path="/dashboard-admin"
    element={
      <ProtectedRoute ruoliConsentiti={["admin"]}>
        <DashboardAdmin />
      </ProtectedRoute>
    }
  />

<Route
  path="/analytics-accessi"
  element={
    <ProtectedRoute ruoliConsentiti={["admin"]}>
      <AnalyticsAccessi />
    </ProtectedRoute>
  }
/>

  <Route
    path="/gestione-demo"
    element={
      <ProtectedRoute ruoliConsentiti={["admin"]}>
        <GestioneDemo />
      </ProtectedRoute>
    }
  />

<Route
  path="/demo-leads"
  element={
    <ProtectedRoute ruoliConsentiti={["admin"]}>
      <DemoLeads />
    </ProtectedRoute>
  }
/>

  {/* Admin: Report */}
  <Route
    path="/report-admin"
    element={
      <ProtectedRoute ruoliConsentiti={["admin"]}>
        <ReportAdmin />
      </ProtectedRoute>
    }
  />

<Route path="/piani" element={<Pricing />} />

  {/* Contatti */}
  <Route path="/contatti" element={<Contatti />} />

<Route path="/privacy-policy" element={<PrivacyPolicy />} />
<Route path="/cookie-policy" element={<CookiePolicy />} />

  <Route path="/demo" element={<Demo />} />
  {/* Home pubblica */}

<Route
  path="/app-asporto"
  element={<AppAsporto />}
/>

<Route
  path="/menu-ai"
  element={<MenuAI />}
/>
<Route
  path="/menu-digitale-ristoranti"
  element={<MenuDigitaleRistoranti />}
/>

<Route
  path="/menu-digitale-pizzerie"
  element={<MenuDigitaleRistoranti />}
/>

<Route
  path="/street-food"
  element={<StreetFood />}
/>

<Route path="/" element={<Home />} />

{/* Default */}
<Route path="*" element={<NotFound />} />

      </Routes>

      <CookieConsent />
    </>
  );
}

export default App;
